<template>
    <el-popover
        ref="task-edit"
        placement="top"
        title=""
        width="870"
        trigger="manual"
        v-model="showExpenseEdit"
        :visible-arrow="false"
        popper-class="expense-deal-create"
    >
        <el-row class="mb10">
            <el-col :span="24" class="label" v-if="issetCurrentExpenseId">
                <expense-deal-create
                    :id="currentExpenseId"
                    :expense-default="expense"
                    @closePopUp="closePopUp"
                />
            </el-col>
        </el-row>
    </el-popover>
</template>

<script>
import '@/assets/styles/expenses-deals-create.scss';
import { mixin as clickaway } from 'vue-clickaway';
import ExpenseDealCreate from '@/components/expenses/ExpenseDealCreate';

export default {
    name: 'ExpenseDealCreatePopup',
    mixins: [
        clickaway
    ],
    data() {
        return {
            showExpenseEdit: false,
            currentExpenseId: null,
            expenseDefault: []
        };
    },
    props: {
        expenseId: {
            type: Number,
            default: 0
        },
        isVisible: {
            type: Boolean,
            default: false
        },
        expense: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        ExpenseDealCreate
    },
    computed: {
        issetCurrentExpenseId() {
            return +this.currentExpenseId > 0 || this.currentExpenseId === -1;
        }
    },
    methods: {
        closePopUp(value) {
            this.showExpenseEdit = value;
            this.currentExpenseId = null;
            this.$emit('changeVisibility', value);
        },
        hideForm(event) {
            if (this.showExpenseEdit && !(event.target.id === ('create-expense-regular')) && !event.target.classList.contains('create-expense-regular-title')) {
                this.showExpenseEdit = false;
                this.currentExpenseId = null;
                this.$emit('changeVisibility', false);
            }
        }
    },
    watch: {
        isVisible(value) {
            this.showExpenseEdit = value;
        },
        expenseId(value) {
            this.currentExpenseId = value;
        },
        expense(value) {
            this.expenseDefault = value;
        }
    }
};
</script>
